import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountSuperAdminUserCredit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSuperAdminUserCreditContainer";
    }
    render(){
        // console.log("SuperAdmin user edit");
    }
}